import { EPanelOpenMethod } from '@components/block-event-single/store';
import { EEventManagementTabsType } from '@src/common/constant/enum';
import { IBlockEventData } from '@src/common/types/empTypes';
import { MappedEvent } from '@src/emp-3.0/types/mapped-event';

export enum EEventInfoKey {
  DESCRIPTION = 'description',
  EVENT_NAME = 'event_name',
  EVENT_CATEGORY = 'event_category',
}

export interface IOnChangeEventInfo {
  type?: EEventManagementTabsType;
  key?: EEventInfoKey;
  value?: string;
}

export interface IEventInfoCard {
  mode?: EPanelOpenMethod;
  type?: EEventManagementTabsType;
  blockEvent?: IBlockEventData;
  mappedEvent?: MappedEvent;
  onChangeEventInfo?: (infoValue?: IOnChangeEventInfo) => void;
}
